import { createTypes, createAsyncTypes } from '../../utils';

const prefix = 'countrySelection';

const types = createTypes(prefix, [
    'SET_COUNTRY'
]);

const asyncTypes = createAsyncTypes(prefix, [
    'SAVE_COUNTRY'
]);

export default {
    ...types,
    ...asyncTypes
};
